export default __webpack_public_path__ + "static/media/fiolet_video.2d86d320.svg";